import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import {COLORS} from "../../utils"

const useStyles = makeStyles(() => ({
    dialog: {
        textAlign: "justify",
        color: COLORS.GREY_SEARCH,
        fontSize: 16,
        "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0,0,0,0.1)"
        }
    },
    rootDialogActions: {
        justifyContent: "space-between",
        padding: 15,
        marginBottom: 15
    },
    title: {
        fontWeight: 500,
        fontSize: 17,
    },
    dialogTitle: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 0,
    },
    dialogTitleLabel: {
        fontWeight: 500,
        marginTop: 5,
        fontSize: 20,
        lineHeight: "24px",
        width: 596
    }
}))

const ConnectedChangedModal = (props) => {
    const {
        open,
        count,
        onClose,
        action
    } = props

    const classes = useStyles()

    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            className={classes.dialog}
        >
            <DialogTitle
                id="customized-dialog-title"
                onClose={onClose}
                classes={{root: classes.dialogTitle}}>
            </DialogTitle>
            <DialogContent>
                <p>
                    Les modifications apportées à cette section réutilisable vont automatiquement être appliquées sur {count} recettes utilisant cette section. Êtes-vous sûr(e) de vouloir continuer ?
                </p>
            </DialogContent>
            <DialogActions classes={{root: classes.rootDialogActions}}>
                <Button
                    color="primary"
                    onClick={onClose}
                >
                    ANNULER LES MODIFICATIONS
                </Button>
                <Button
                    color="secondary"
                    type="submit"
                    onClick={action}
                >
                    METTRE A JOUR TOUTES LES RECETTES
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConnectedChangedModal
